import { render } from "./Footer-l.vue?vue&type=template&id=162c05fb&scoped=true"
const script = {}

import "./Footer-l.vue?vue&type=style&index=0&id=162c05fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-162c05fb"]])

export default __exports__